<template>
  <div class="bank">
    <bank-container></bank-container>
  </div>

</template>
<script>
import BankContainer from '@/components/bank/Container.vue'
export default {
  name: 'bank',
  data () {
    return {
    }
  },
  components: {
    BankContainer
  }
}
</script>
<style lang="stylus">
.bank
  width 100%
  height 100%
  background #F7F9FB
</style>
